function makeCancelable(promise, onfulfilled, onrejected) {
  var hasCanceled = false;
  new Promise(function (resolve, reject) {
    return promise.then(function (val) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : resolve(val);
    })["catch"](function (err) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : reject(err);
    });
  }).then(onfulfilled)["catch"](function (err) {
    if (err && !err.isCanceled) {
      throw err;
    }
  })["catch"](onrejected);
  return function () {
    hasCanceled = true;
  };
}

export default makeCancelable;
